import { SecretNetworkClient } from "secretjs";

export interface Coin {
  readonly denom: string;
  readonly amount: string;
}
export interface TxnStdFee {
  readonly amount: Coin[];
  readonly gas: string;
}
export interface StdFee {
  readonly upload: TxnStdFee;
  readonly init: TxnStdFee;
  readonly exec: TxnStdFee;
  readonly send: TxnStdFee;
  readonly amount: Coin[];
  readonly gas: string;
}

export interface ExecArgs {
  userAddress: string;
  transferAmount: readonly Coin[] | undefined;
  customFees: TxnStdFee | undefined;
}

export class Contract {
  private client: SecretNetworkClient;

  public contractCodeHash: string | undefined;
  public contractAddress: string;

  constructor(
    client: SecretNetworkClient,
    contractAddress: string,
    contractHash?: string
  ) {
    this.contractCodeHash = contractHash;
    this.contractAddress = contractAddress;
    this.client = client;
  }

  async queryMsg(msgData: Record<string, unknown>): Promise<any> {
    return await this.client.query.compute.queryContract({
      contract_address: this.contractAddress,
      query: msgData,
      code_hash: this.contractCodeHash,
    });
  }

  async executeMsg(
    msgData: Record<string, unknown>,
    userAddress: string,
    customFees?: TxnStdFee,
    memo?: string,
    transferAmount?: readonly Coin[]
  ): Promise<any> {
    const inGasLimit = parseInt(customFees?.gas as string);
    const inGasPrice = (customFees?.amount.length as number > 0)?
      parseFloat(customFees?.amount[0].amount as string) /
      parseFloat(customFees?.gas as string): undefined;

    // Send the same handleMsg to increment multiple times
    return await this.client.tx.compute.executeContract(
      {
        sender: userAddress,
        contract_address: this.contractAddress,
        code_hash: this.contractCodeHash,
        msg: msgData,
        sent_funds: transferAmount as Coin[] | undefined,
      },
      {
        gasLimit: Number.isNaN(inGasLimit) ? undefined : inGasLimit,
        gasPriceInFeeDenom: Number.isNaN(inGasPrice) ? undefined : inGasPrice,
        memo: memo,
      }
    );
  }
}
